var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c("div", { staticClass: "card setting-card" }, [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("general.credit_limit"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6 mb-6" }, [
          _c("label", { staticClass: "input-label" }, [
            _vm._v(_vm._s(_vm.$tc("general.credit_limit"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "base-read-box base-read-box-field" }, [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$utils.formatMoney(
                    _vm.credit_limit,
                    _vm.customerCurrencyViewFormat
                  )
                ),
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-6" }, [
          _c("label", { staticClass: "input-label" }, [
            _vm._v(_vm._s(_vm.$tc("general.used_credit"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "base-read-box base-read-box-field" }, [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$utils.formatMoney(
                    _vm.used_credit,
                    _vm.customerCurrencyViewFormat
                  )
                ),
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-4" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("p", { staticClass: "text-center" }, [
              _vm._v(" Total Credit Limit "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$utils.formatMoney(
                      _vm.total_credit_limit,
                      _vm.customerCurrencyViewFormat
                    )
                  ),
                },
              }),
            ]),
            _vm._v(" "),
            _vm.isLoading
              ? _c("pie-chart", {
                  attrs: {
                    labels: _vm.CrditLimitLabels,
                    values: _vm.CreditLimitData,
                    "bg-colors": _vm.bgColors,
                    "hover-bg-colors": _vm.hoverBgColors,
                    type: "pie",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }